module.exports = __webpack_public_path__ + "img/login_slogan_es@2x.ad300eb1.png";